import { LazyLoader, showToast } from '@bp/ui-components';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { Page } from '../../../../components/Page/Page';
import { EventSyncStatusLine } from '../../../../components/Synchronizations/EventSyncStatusLine';
import { SynchronizationsTable } from '../../../../components/Synchronizations/tables/SynchronizationsTable';
import { useAuthClaims } from '../../../../hooks/useAuthClaims';
import { useConfirm } from '../../../../hooks/useConfirm';
import { usePermissionChecker } from '../../../../hooks/usePermissionChecker';
import { useSelectedSchoolYear } from '../../../../hooks/useSelectedSchoolYear';
import { createEvents } from '../../../../utils/eventsApi';

export const SynchronizationPage = () => {
  const { t } = useTranslation();
  const { pimAuthClaims } = useAuthClaims();
  const schoolYear = useSelectedSchoolYear();
  const permissions = usePermissionChecker();

  const { confirm, ConfirmationDialog } = useConfirm();

  async function handleSync() {
    const result = await confirm({
      title: t('synchronizations.confirmTitle'),
      message: t('synchronizations.confirmMessage'),
      confirmText: t('synchronizations.syncNow'),
    });

    if (result && schoolYear) {
      await createEvents({
        organizationUuid: pimAuthClaims.getOrganizationUuid(),
        schoolYearUuid: schoolYear?.uuid,
      });
      showToast(t('synchronizations.started'), { type: 'success' });
    }
  }

  return (
    <Page isForbidden={!permissions?.canWriteSubstitution()} headline={t('synchronizations.synchronization')}>
      <Suspense fallback={<LazyLoader transparent forceHeight='50vh' fullWidth size='xxl' />}>
        <EventSyncStatusLine />
        <SynchronizationsTable onSync={handleSync} />
      </Suspense>

      <ConfirmationDialog />
    </Page>
  );
};
